import { useContext } from "react";
import { useAssignmentProposalStore } from "@context/useAssignmentProposalStore";
import { isLinkLockedByProposal } from "@utils/assignmentProposal";
import { AppContext } from "../context/EditSessionsContext";
import { useIsLinkClosedToProposals } from "./useIsLinkClosedToProposals";

/**
 * True while the editor of the current link shows a proposal nobody may change from it, or a link
 * closed to proposals. The editor keeps showing its content but no action may change it.
 */
export const useIsEditorLocked = (): boolean => {
  const { state } = useContext(AppContext);
  const activeProposal = useAssignmentProposalStore(store => store.activeProposal);
  const isClosedToProposals = useIsLinkClosedToProposals();

  return isLinkLockedByProposal(activeProposal, state?.link?.info?.id) || isClosedToProposals;
};
